module.exports = __webpack_public_path__ + "img/awithdraw.b21b47ca.png";